var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconQuotesActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7499 13.75V17.5H3.74994V2.49997H9.99994V1.24997H3.74994C3.41842 1.24997 3.10048 1.38167 2.86606 1.61609C2.63163 1.85051 2.49994 2.16845 2.49994 2.49997V17.5C2.49994 17.8315 2.63163 18.1494 2.86606 18.3839C3.10048 18.6183 3.41842 18.75 3.74994 18.75H13.7499C14.0815 18.75 14.3994 18.6183 14.6338 18.3839C14.8682 18.1494 14.9999 17.8315 14.9999 17.5V13.75H13.7499Z",
    fill: "#F8B218"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4624 3.59997L16.3999 1.53747C16.213 1.35424 15.9617 1.25161 15.6999 1.25161C15.4382 1.25161 15.1869 1.35424 14.9999 1.53747L6.24994 10.2875V13.75H9.70619L18.4562 4.99997C18.6394 4.81304 18.742 4.56172 18.742 4.29997C18.742 4.03821 18.6394 3.7869 18.4562 3.59997H18.4624ZM9.18744 12.5H7.49994V10.8125L13.3999 4.90622L15.0937 6.59997L9.18744 12.5ZM15.9749 5.71872L14.2812 4.02497L15.6999 2.60622L17.3937 4.29997L15.9749 5.71872Z",
    fill: "#F8B218"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuotesActive);
export default __webpack_public_path__ + "static/media/icon_quotes_active.9dd7370b9a21b03cff2bc761af945ca7.svg";
export { ForwardRef as ReactComponent };